<template>
    <div>
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="isChecked"
            style="padding-bottom: 2px;"
        >
            <circle cx="8" cy="8" r="8" fill="#206CFF" />
            <circle cx="8" cy="8" r="3" fill="white" />
        </svg>
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-else
            style="padding-bottom: 2px;"
        >
            <circle cx="8" cy="8" r="7.5" fill="white" stroke="#C8D0DD" />
        </svg>
    </div>
</template>
<script>
export default {
    name: "RadioOption",
    props: {
        isChecked: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
